import { Component, input, output, OnInit } from '@angular/core';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { IntroStep } from '../../../core/services/tour.service';

@Component({
    selector: 'wf-district-report-container',
    templateUrl: './district-report-container.component.html',
    styleUrls: ['./district-report-container.component.css'],
    standalone: false
})
export class DistrictReportContainer implements OnInit {
  reportTitle = input<string>('Report Title');
  loadError = input<string>('');
  tourSteps = input<IntroStep[]>([]);
  onPrint = output<void>();
  printIcon = faPrint;

  constructor() {}

  ngOnInit(): void {}

  onPrintClicked(): void {
    this.onPrint?.emit();
  }
}
